import React from 'react';
import { alpha, Box, Stack, Typography } from '@mui/material';
import { MONO } from './scanUi';
import { gradeOf } from './riskLogic';
import { SCOPE_COLOR, SCOPE_LABEL } from './findingsLogic';

const HINT = { external: 'Seen from the internet', internal: 'Seen from inside the network' };

// One grade per scope, so a quiet internal network cannot hide a weak internet-facing side (or the other way round).
export default function ScopeGrades({ scopes }) {
  const ids = ['external', 'internal'].filter((id) => scopes?.[id]);
  if (!ids.length) return null;
  return (
    <Stack direction="row" gap={2} flexWrap="wrap">
      {ids.map((id) => {
        const s = scopes[id];
        const g = gradeOf(s.grade);
        return (
          <Box key={id} sx={{ flex: '1 1 320px', p: 2.4, borderRadius: 3, border: 1, borderColor: alpha(SCOPE_COLOR[id], 0.45), bgcolor: 'background.paper', display: 'flex', alignItems: 'center', gap: 2.5 }}>
            <Box sx={{ textAlign: 'center', minWidth: 64 }}>
              <Typography sx={{ fontSize: 40, fontWeight: 800, fontFamily: MONO, lineHeight: 1, color: g.color }}>{s.grade}</Typography>
              <Typography variant="caption" color="text.secondary">score {s.score}</Typography>
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={{ fontWeight: 700, color: SCOPE_COLOR[id] }}>{SCOPE_LABEL[id]}</Typography>
              <Typography variant="body2" color="text.secondary">{HINT[id]}</Typography>
              <Typography variant="body2" sx={{ mt: 0.5 }}>
                <b style={{ fontFamily: MONO }}>{s.open}</b> open{s.severity.critical ? `, ${s.severity.critical} critical` : ''}{s.severity.high ? `, ${s.severity.high} high` : ''}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Stack>
  );
}
